import { forwardRef, PropsWithChildren } from "react";

const PageOnMapContainer = forwardRef<HTMLDivElement,PropsWithChildren>(function (props, ref) {
  return (
    <div className="bar-paddings absolute-pages-content" ref={ref}>{props.children}</div>
  );
})

export default PageOnMapContainer